import React, { useMemo } from 'react';
import Style from './style.module.css';

const Select = ({
  name,
  register,
  errors,
  validation,
  attrLabel = 'value',
  attrValue = 'value',
  defaultOption = null,
  options = [],
  ...props
} = {}) => {
  if (register) {
    props.ref = register({ ...validation });
  }

  const optionsEl = useMemo(() => {
    return options.map(option => (
      <option key={option[attrValue]} value={option[attrValue]}>
        {option[attrLabel]}
      </option>
    ));
  }, [options]);

  return (
    <div className={Style.textInputContainer}>
      <select name={name} {...props}>
        {defaultOption && <option value="">{defaultOption}</option>}
        {optionsEl}
      </select>
      {errors[name] && (
        <span className={Style.errorMsg}>{errors[name].message}</span>
      )}
    </div>
  );
};

export default Select;
